import React from 'react';
import { connectStats } from 'react-instantsearch-dom';
import classNames from 'classnames';
import styles from './ProgressBar.module.scss';

const ProgressBar = connectStats(props => {
  const totalHits = Number(props.nbHits) || 0;
  const visibleHits = Number(props.hits.length) || 0;
  return (
    <div className="load-more-container">
      <div className="has-text-centered">
        <p className={styles.searchResults}>
          Showing {visibleHits} of {totalHits} results.
        </p>
      </div>
      <div className="level">
        <div className="level-item is-hidden-mobile" />
        <div className="level-item">
          <progress
            className={classNames('progress', styles.progress)}
            value={visibleHits}
            max={totalHits}
          />
        </div>
        <div className="level-item is-hidden-mobile" />
      </div>
    </div>
  );
});

export { ProgressBar };
